//@ts-nocheck
import Swiper from "swiper";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";

const relatedSlider = () => {
  const slider = new Swiper(".js-related-swiper", {
    slidesPerView: 1.1,
    spaceBetween: 16,
    breakpoints: {
      1440: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 2.2,
      },
      768: {
        slidesPerView: 1.6,
      },
    },
  });
};

export default relatedSlider;
